export default "__VITE_ASSET__DkPXp$O9__"